import { Button, Col, Row } from "reactstrap";

const styles =
  "w-100 border rounded bg-white bg-ultralight--hover pl-3 pr-2 py-2 my-3 cursor-pointer text-dark font-weight-500";

interface SettingsGroupCardProps {
  title: string;
  description: string;
  onClick: () => void;
}

const SettingsGroupCard = ({
  onClick,
  title,
  description,
}: SettingsGroupCardProps) => {
  return (
    <div className={styles} onClick={onClick}>
      <Row className="align-items-center">
        <Col xs="">
          {title}
          <p className="m-0 small text-muted">{description}</p>
        </Col>
        <Col xs="auto">
          <Button size="sm" outline color="secondary" className="btn-icon-only">
            <i className="mdi mdi-chevron-right"></i>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SettingsGroupCard;
